<template>
  <span
    class="tw-inline-flex tw-gap-x-2 tw-items-center tw-text-sm tw-font-bold tw-select-none tw-text-gray-400 tw-uppercase"
  >
    <slot />
  </span>
</template>
